module.exports = __webpack_public_path__ + "img/ia-02-3.16c48633.jpg";